<script lang="ts" setup>
import { AppTopbar } from '~/components/layout';

useHead({
  bodyAttrs: {
    class: 'bg-[#F1F5F9]!',
  },
  htmlAttrs: {
    class: 'bg-[#F1F5F9]!',
  },
});
</script>

<template>
  <div class="onboarding-layout min-h-screen bg-[#F1F5F9]">
    <AppTopbar mode="auth" />
    <div class="onboarding-layout__content flex flex-1 justify-center">
      <Transition name="page" mode="out-in">
        <NuxtPage :page-key="(route) => route.fullPath" />
      </Transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.onboarding-layout {
  display: flex;
  flex-direction: column;
}

.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease;
}

.page-enter-from {
  opacity: 0;
}

.page-leave-to {
  opacity: 0;
}
</style>
